import { render, staticRenderFns } from "./researcherDetailDialog.vue?vue&type=template&id=1429d828"
import script from "./researcherDetailDialog.vue?vue&type=script&lang=js"
export * from "./researcherDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./researcherDetailDialog.vue?vue&type=style&index=0&id=1429d828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports